import { ReactNode } from 'react';
import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { Button } from '@givebutter/primitives/button';
import { useCampaignItemRoutes } from 'components/pages/campaign-settings/campaign-auction/useCampaignItemRoutes';
import { AuctionItem } from 'types/domain';

interface ExportItemQRCodeProps {
    item: AuctionItem;
    children?: ReactNode;
}

const ExportItemQRCode = (props: ExportItemQRCodeProps) => {
    const { item, children } = props;
    const itemRoutes = useCampaignItemRoutes();

    return (
        <AlertDialog.Root>
            {children}
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content className={'w-96'}>
                    <AlertDialog.Header>
                        <AlertDialog.Title className={'text-center'}>
                            Download QR Code
                        </AlertDialog.Title>
                        <AlertDialog.Close />
                    </AlertDialog.Header>
                    <AlertDialog.Body
                        className={'flex w-full flex-col items-center justify-center text-center'}
                    >
                        <div
                            className={
                                'flex h-56 w-56 items-center justify-center rounded-[1.25rem] border-2 border-gray-200 bg-gray-50'
                            }
                        >
                            <div
                                className={
                                    'flex h-44 w-44 items-center justify-center rounded-[1.25rem] border-[0.125rem] border-gray-200 bg-white text-center'
                                }
                            >
                                <img
                                    className={'h-36 w-36'}
                                    src={item?.qr?.image}
                                    alt={`${item.name} QR Code`}
                                />
                            </div>
                        </div>
                        <p className={'mt-3 font-medium'}>{item.name}</p>
                    </AlertDialog.Body>
                    <AlertDialog.Footer className={'justify-between gap-4'}>
                        <Button
                            variant="outline"
                            size="sm"
                            color="neutral"
                            className={'h-10 w-full'}
                            /**
                             *  The e.preventDefault from dropdown.item prevents the link from working, so for now
                             *  opening a new tab using window methods seems to be the way
                             */
                            onClick={() => window.open(itemRoutes.exportQRCode(item.id), '_blank')}
                        >
                            QR Code Only
                        </Button>
                        <Button
                            variant="solid"
                            size="sm"
                            /**
                             *  The e.preventDefault from dropdown.item prevents the link from working, so for now
                             *  opening a new tab using window methods seems to be the way
                             */
                            onClick={() =>
                                window.open(itemRoutes.exportQRCodeDetailed(item.id), '_blank')
                            }
                            className={'h-10 w-full'}
                        >
                            QR Code & Details
                        </Button>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

const ExportItemQRCodeTrigger = AlertDialog.Trigger;

const Root = ExportItemQRCode;
const Trigger = ExportItemQRCodeTrigger;

export {
    ExportItemQRCode,
    ExportItemQRCodeTrigger,
    //
    Root,
    Trigger,
};
export type { ExportItemQRCodeProps };
